import "./Popup.css";

const Popup = ({ id, title, onClose, children }) => {
    return (
        <div id={id} className="chiuso popup">
            <div className="title-cont">
                {title && <h1 className="popup-title">{title}</h1>}
                <i className="fa-solid fa-close popup-close" onClick={onClose}></i>
            </div>
            <div className="popup-content">
                {children}
            </div>
        </div>
    );
};

export default Popup;
